import React from "react";
import InputTextSection from "./InputTextSection";
import { CREATIVE_NAMES, MULTI_BIDDER_CREATIVE_AD_FIELDS } from "./definitions";
import BaseCreativeControls from "./BaseCreativeControls";

const CREATIVE_TYPE = CREATIVE_NAMES.MULTI_FORMAT_BIDDER;


/**
 * 
 * @param {Object} creativeConfig 
 * @param {"default" | "banner" | "rail" | "responsive"} creativeConfig.format
 * @returns 
 */
export default function MultiFormatBidder({
    container,
    handleChange,
    impressionTag,
    wrapperUrl,
    gamAdUnitPath,
    adServingType,
}) {

    return (
        <>
            <BaseCreativeControls
                isClickTagRequired={false}
                adServingType={adServingType}
                changeHandler={handleChange}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
                renderClickUrlInput={false}
            >

                <InputTextSection
                    label="Ad Wrapper URL"
                    name={MULTI_BIDDER_CREATIVE_AD_FIELDS.wrapperUrl}
                    value={wrapperUrl}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    textInput={true}
                    placeHolder="Mini-wrapper URL"
                    required={false}
                    uriEncodeValue={false} />

                <InputTextSection
                    label="Base Ad Unit Path"
                    name={MULTI_BIDDER_CREATIVE_AD_FIELDS.gamAdUnitPath}
                    value={gamAdUnitPath}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    textInput={true}
                    placeHolder="Base Ad Unit Path"
                    required={false}
                    uriEncodeValue={false} />


                <InputTextSection
                    label="Wrapper/div css selector (optional)"
                    name={MULTI_BIDDER_CREATIVE_AD_FIELDS.container}
                    value={container}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    textInput={true}
                    required={false}
                    uriEncodeValue={false}
                />
            </BaseCreativeControls>

        </>
    );
}
